package component.image

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import io.kamel.image.KamelImage
import io.kamel.image.asyncPainterResource

@Composable
fun AsyncImageView(url: String, onFail: (() -> Unit) = {}) {
    Box {
        KamelImage(
            modifier = Modifier.background(Color.Transparent),
            resource = asyncPainterResource(data = url),
            contentDescription = "Membership Code",
            onLoading = { progress -> CircularProgressIndicator(progress) },
            onFailure = { exception ->
                if (onFail != null) {
                    onFail()
                }
            }
        )
    }
}